import 'normalize.css'
import '@revolut-internal/ui-kit/styles.css'

import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

import { Bootstrap } from 'containers/Bootstrap'
import { setupSentry } from 'lib/sentry'

function renderApp() {
  const container = document.getElementById('mount')

  if (container !== null) {
    const root = createRoot(container)

    root.render(createElement(Bootstrap))
  } else {
    console.error('HTML element #mount does not exist, cannot render application')
  }
}

if (process.env.NODE_ENV === 'production') {
  setupSentry().withScope(() => {
    renderApp()
  })
} else {
  renderApp()
}
